<vpg-inline-label
    class="recommendation-card-tag"
    [id]="id"
    [size]="size"
    [category]="category"
    [variant]="variant"
>
    {{ tag }}
</vpg-inline-label>
